const TYPOGRAPHY_TAGS = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  P: 'p',
  SPAN: 'span'
};
const COLORS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DARK_GREY: 'darkGrey',
  GREY: 'grey',
  LIGHT_GREY: 'lightGrey',
  BLACK: 'black',
  WHITE: 'white'
};
const SURFACES = {
  EXTEND: 'extend',
  EXTEND_ROUNDED: 'extend rounded',
  NORMAL: 'normal',
  BORDER_RADIUS: 'border radius',
  BOX_SHADOW: 'box shadow'
};
const ELEVATION = {
  LOW: 'LOW',
  HIGH: 'HIGH'
};
const BORDER_RADIUS = {
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE'
};
const VR_LINEHEIGHT = {
  ALL: 'ALL'
};
const CONFIGURATION_TYPES = {
  COLOR: 'COLOR',
  TYPOGRAPHY: 'TYPOGRAPHY',
  SURFACE: 'SURFACE',
  VR_LINEHEIGHT: 'VERTYCAL_RHYTHM'
};

const baseConfiguration = {
  onTopCard: [{
    name: 'cardTextColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'surfaceStyle',
    value: SURFACES.EXTEND,
    type: CONFIGURATION_TYPES.SURFACE
  }],
  verticalCard: [{
    name: 'cardBackgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTextColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'surfaceStyle',
    value: SURFACES.EXTEND,
    type: CONFIGURATION_TYPES.SURFACE
  }],
  horizontalCard: [{
    name: 'cardBackgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTextColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'surfaceStyle',
    value: SURFACES.EXTEND,
    type: CONFIGURATION_TYPES.SURFACE
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  cardCaptionContainer: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  cardOverlay: [{
    name: 'cardOverlayColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  headlinesArticleList: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  oneThreeArticleList: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  decorationLine: [{
    name: 'cardDecorationColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  sectionHeader: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'idleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'visitedStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  listWithHeading: [{
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'surfaceStyle',
    value: SURFACES.NORMAL,
    type: CONFIGURATION_TYPES.SURFACE
  }],
  list: [{
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'surfaceStyle',
    value: SURFACES.NORMAL,
    type: CONFIGURATION_TYPES.SURFACE
  }],
  listItem: [{
    name: 'borderColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkHoverColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  scrollableArticleList: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  sixSixArticleList: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  button: [{
    name: 'backgroundColorEnabled',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorEnabled',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColorDisabled',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorDisabled',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'surfaceStyleEnabled',
    value: SURFACES.EXTEND_ROUNDED,
    type: CONFIGURATION_TYPES.SURFACE
  }, {
    name: 'surfaceStyleDisabled',
    value: SURFACES.EXTEND_ROUNDED,
    type: CONFIGURATION_TYPES.SURFACE
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  h1: [{
    name: 'tagStyle',
    value: TYPOGRAPHY_TAGS.H1,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }],
  h2: [{
    name: 'tagStyle',
    value: TYPOGRAPHY_TAGS.H2,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }],
  h3: [{
    name: 'tagStyle',
    value: TYPOGRAPHY_TAGS.H3,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }],
  h4: [{
    name: 'tagStyle',
    value: TYPOGRAPHY_TAGS.H4,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }],
  span: [{
    name: 'tagStyle',
    value: TYPOGRAPHY_TAGS.SPAN,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }],
  p: [{
    name: 'tagStyle',
    value: TYPOGRAPHY_TAGS.P,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }],
  ul: [{
    name: 'tagStyle',
    value: TYPOGRAPHY_TAGS.P,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }],
  main: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  mainPostPage: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  highlightsArticleList: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  primaryHeader: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'backgroundColor',
    value: COLORS.BLACK,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'surfaceStyle',
    value: SURFACES.BOX_SHADOW,
    type: CONFIGURATION_TYPES.SURFACE
  }],
  primaryLinks: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'visitedStateColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeBorderBottom',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverOtherLinksColors',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  editions: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  editionsMenu: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'menuBackgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'surfaceStyle',
    value: SURFACES.BOX_SHADOW,
    type: CONFIGURATION_TYPES.SURFACE
  }],
  ctaButton: [{
    name: 'backgroundColorNormal',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorNormal',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorNormal',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColorHover',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColorActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorActive',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorActive',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'surfaceStyle',
    value: SURFACES.BORDER_RADIUS,
    type: CONFIGURATION_TYPES.SURFACE
  }],
  footer: [{
    name: 'backgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderTopColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'separatorColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  footerLinksSection: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'visitedStateColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  footerMobileStores: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  secondaryHeader: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'backgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'surfaceStyle',
    value: SURFACES.BOX_SHADOW,
    type: CONFIGURATION_TYPES.SURFACE
  }],
  secondaryLinks: [{
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'hoverOtherLinksColors',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  moreLinks: [{
    name: 'titleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'menuBackgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'surfaceStyle',
    value: SURFACES.BOX_SHADOW,
    type: CONFIGURATION_TYPES.SURFACE
  }],
  menuIcon: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  ampCloseMenuIcon: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  menuLinks: [{
    name: 'backgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'dividerColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  menuLink: [{
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  menuSubLink: [{
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  footerSocialLinks: [{
    name: 'titleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'circleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  bottomFooterBar: [{
    name: 'backgroundColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  errorPage: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'buttonColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'buttonBackgroundColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  articleTitle: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'titleColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'metaDataColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  postSidebar: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  articleMainImage: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  imageWithFigcaptionWrapper: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'figcaptionTextColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  imageWrapper: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  articleParagraph: [{
    name: 'linkColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  articleContent: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  quote: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'borderColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'citeColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'iconColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  divider: [{
    name: 'color',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  mmPlayer: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  iframeEmbed: [{
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  iframe: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  postMainContent: [{
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  streamable: [{
    name: 'backgroundColor',
    value: COLORS.BLACK,
    type: CONFIGURATION_TYPES.COLOR
  }],
  listItemTitle: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'titleColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'numberColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  articleShareButton: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'buttonBackgroundColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'buttonHoverColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  copyLinkButton: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  playIcon: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'fillColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'lineColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  mobileTopBar: [{
    name: 'backgroundColor',
    value: COLORS.BLACK,
    type: CONFIGURATION_TYPES.COLOR
  }],
  taboola: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  postRecommendations: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  postRecommendationsHeader: [{
    name: 'color',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  recommendationCardPlaceHolder: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  ampSocialContainer: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  sponsor: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'dividerColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  authorPage: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'metaDataColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'color',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  authorImage: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'surfaceStyle',
    value: SURFACES.NORMAL,
    type: CONFIGURATION_TYPES.SURFACE
  }],
  authorPageSocial: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'backgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  authorPageFeed: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }],
  authorTopGradient: [{
    name: 'vrLineHeight',
    value: VR_LINEHEIGHT.ALL,
    type: CONFIGURATION_TYPES.VR_LINEHEIGHT
  }, {
    name: 'color',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }]
};

class ConfigurationBuilder {
  constructor(overrides = { ...baseConfiguration
  }) {
    this.overrides = overrides;
  }

  replaceValueInElement(componentName, propName, value) {
    return this.overrides[componentName].map(element => {
      if (element.name === propName) {
        return { ...element,
          value
        };
      }

      return element;
    });
  }

  overrideColor(componentName, propName, color) {
    this.overrides[componentName] = this.replaceValueInElement(componentName, propName, color);
    return this;
  }

  overrideSurfaceStyle(componentName, propName, surfaceStyle) {
    this.overrides[componentName] = this.replaceValueInElement(componentName, propName, surfaceStyle);
    return this;
  }

  build() {
    return { ...this.overrides
    };
  }

}

const configurationBuilder = () => new ConfigurationBuilder();

const configuration = configurationBuilder().overrideColor('verticalCard', 'cardTextColor', 'primary').overrideColor('horizontalCard', 'cardTextColor', 'primary').overrideColor('cardOverlay', 'cardOverlayColor', 'black').overrideColor('decorationLine', 'cardDecorationColor', 'primary').overrideColor('sectionHeader', 'titleColor', 'secondary').overrideColor('sectionHeader', 'idleColor', 'secondary').overrideColor('sectionHeader', 'hoverStateColor', 'secondary').overrideColor('sectionHeader', 'activeStateColor', 'secondary').overrideColor('listWithHeading', 'titleColor', 'secondary').overrideColor('listItem', 'linkColor', 'primary').overrideColor('listItem', 'linkHoverColor', 'secondary').overrideSurfaceStyle('button', 'surfaceStyleEnabled', 'extend').overrideSurfaceStyle('button', 'surfaceStyleDisabled', 'normal').overrideColor('primaryHeader', 'backgroundColor', 'primary').overrideColor('primaryLinks', 'hoverStateColor', 'white').overrideColor('primaryLinks', 'activeStateColor', 'white').overrideColor('primaryLinks', 'activeBorderBottom', 'white').overrideColor('primaryLinks', 'hoverOtherLinksColors', 'grey').overrideColor('editionsMenu', 'menuBackgroundColor', 'primary').overrideColor('footer', 'separatorColor', 'primary').overrideColor('secondaryLinks', 'hoverStateColor', 'white').overrideColor('secondaryLinks', 'hoverOtherLinksColors', 'grey').overrideColor('moreLinks', 'hoverColor', 'white').overrideColor('mobileTopBar', 'backgroundColor', 'primary').build();

const colors = {
  [COLORS.PRIMARY]: '#1493FF',
  [COLORS.SECONDARY]: '#1F375B',
  [COLORS.DARK_GREY]: '#445058',
  [COLORS.GREY]: '#B9C4CB',
  [COLORS.LIGHT_GREY]: '#F0F3F8',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const elevation = {
  [ELEVATION.LOW]: '0 2px 4px 0 rgba(0,0,0,0.2)',
  [ELEVATION.HIGH]: '0 8px 8px -8px rgba(0,0,0,0.2), 0 4px 20px 0px rgba(0,0,0,0.2), 0 12px 16px 0px rgba(0,0,0,0.2)'
};
const borderRadius = {
  [BORDER_RADIUS.MEDIUM]: '4px'
};
const surfaceStyle = {
  [SURFACES.EXTEND]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius[BORDER_RADIUS.MEDIUM],
      boxShadow: elevation[ELEVATION.LOW],
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      ':active': {
        boxShadow: elevation[ELEVATION.HIGH]
      }
    },
    xLarge: {
      ':hover': {
        boxShadow: elevation[ELEVATION.HIGH]
      }
    },
    large: {
      ':hover': {
        boxShadow: elevation[ELEVATION.HIGH]
      }
    },
    medium: {
      ':hover': {
        boxShadow: elevation[ELEVATION.LOW]
      }
    },
    small: {
      ':hover': {
        boxShadow: elevation[ELEVATION.LOW]
      }
    }
  },
  [SURFACES.EXTEND_ROUNDED]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius[BORDER_RADIUS.LARGE],
      boxShadow: elevation[ELEVATION.LOW],
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      ':active': {
        boxShadow: elevation[ELEVATION.HIGH]
      }
    },
    xLarge: {
      ':hover': {
        boxShadow: elevation[ELEVATION.HIGH]
      }
    },
    large: {
      ':hover': {
        boxShadow: elevation[ELEVATION.HIGH]
      }
    },
    medium: {
      ':hover': {
        boxShadow: elevation[ELEVATION.LOW]
      }
    },
    small: {
      ':hover': {
        boxShadow: elevation[ELEVATION.LOW]
      }
    }
  },
  [SURFACES.NORMAL]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius[BORDER_RADIUS.MEDIUM],
      boxShadow: elevation[ELEVATION.LOW]
    }
  },
  [SURFACES.BORDER_RADIUS]: {
    allSizes: {
      borderRadius: borderRadius[BORDER_RADIUS.MEDIUM]
    }
  },
  [SURFACES.BOX_SHADOW]: {
    allSizes: {
      boxShadow: elevation[ELEVATION.LOW]
    }
  }
};

const fonts = [{
  provider: 'custom',
  family: 'proxima-nova',
  variants: ['400', '600', '700'],
  stylesheetUrl: 'https://use.typekit.net/nxl2plh.css'
}];

const typography = {
  [TYPOGRAPHY_TAGS.H1]: {
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.H2]: {
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.H3]: {
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif',
    style: {
      fontWeight: '600'
    }
  },
  [TYPOGRAPHY_TAGS.H4]: {
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif',
    style: {
      fontWeight: '600'
    }
  },
  [TYPOGRAPHY_TAGS.P]: {
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, Arial, sans-serif',
    style: {
      fontWeight: '400'
    }
  },
  [TYPOGRAPHY_TAGS.SPAN]: {
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, Arial, sans-serif',
    style: {
      fontWeight: '400'
    }
  }
};

const verticalRhythmStrategies = {
  xLarge: {
    fontSize: 16,
    lineHeight: 1.72,
    fontScaleFactor: 1.33,
    lineHeightMap: {
      h1: 2,
      h2: 2,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  large: {
    fontSize: 16,
    lineHeight: 1.53,
    fontScaleFactor: 1.25,
    lineHeightMap: {
      h1: 2,
      h2: 2,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  medium: {
    fontSize: 14,
    lineHeight: 1.5,
    fontScaleFactor: 1.15,
    lineHeightMap: {
      h1: 1.5,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  small: {
    fontSize: 14,
    lineHeight: 1.5,
    fontScaleFactor: 1.15,
    lineHeightMap: {
      h1: 1.5,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  }
};

const palette = {
  colors,
  surfaceStyle,
  fonts,
  typography,
  verticalRhythmStrategies
};

const configuration$1 = configurationBuilder().build();

const colors$1 = {
  [COLORS.PRIMARY]: '#FF9900',
  [COLORS.SECONDARY]: '#1B1B1B',
  [COLORS.DARK_GREY]: '#444444',
  [COLORS.GREY]: '#A1A1A1',
  [COLORS.LIGHT_GREY]: '#F3F3F3',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const elevation$1 = {
  [ELEVATION.LOW]: '0 2px 4px 0 rgba(0,0,0,0.2)',
  [ELEVATION.HIGH]: '0 8px 8px -8px rgba(0,0,0,0.2), 0 4px 20px 0px rgba(0,0,0,0.2), 0 12px 16px 0px rgba(0,0,0,0.2)'
};
const borderRadius$1 = {
  [BORDER_RADIUS.MEDIUM]: '4px',
  [BORDER_RADIUS.LARGE]: '32px'
};
const surfaceStyle$1 = {
  [SURFACES.EXTEND]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$1[BORDER_RADIUS.MEDIUM],
      boxShadow: elevation$1[ELEVATION.LOW],
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      ':active': {
        boxShadow: elevation$1[ELEVATION.HIGH]
      }
    },
    xLarge: {
      ':hover': {
        boxShadow: elevation$1[ELEVATION.HIGH]
      }
    },
    large: {
      ':hover': {
        boxShadow: elevation$1[ELEVATION.HIGH]
      }
    },
    medium: {
      ':hover': {
        boxShadow: elevation$1[ELEVATION.LOW]
      }
    },
    small: {
      ':hover': {
        boxShadow: elevation$1[ELEVATION.LOW]
      }
    }
  },
  [SURFACES.EXTEND_ROUNDED]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$1[BORDER_RADIUS.LARGE],
      boxShadow: elevation$1[ELEVATION.LOW],
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      ':active': {
        boxShadow: elevation$1[ELEVATION.HIGH]
      }
    },
    xLarge: {
      ':hover': {
        boxShadow: elevation$1[ELEVATION.HIGH]
      }
    },
    large: {
      ':hover': {
        boxShadow: elevation$1[ELEVATION.HIGH]
      }
    },
    medium: {
      ':hover': {
        boxShadow: elevation$1[ELEVATION.LOW]
      }
    },
    small: {
      ':hover': {
        boxShadow: elevation$1[ELEVATION.LOW]
      }
    }
  },
  [SURFACES.NORMAL]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$1[BORDER_RADIUS.MEDIUM],
      boxShadow: elevation$1[ELEVATION.LOW]
    }
  },
  [SURFACES.BORDER_RADIUS]: {
    allSizes: {
      borderRadius: borderRadius$1[BORDER_RADIUS.MEDIUM]
    }
  },
  [SURFACES.BOX_SHADOW]: {
    allSizes: {
      boxShadow: elevation$1[ELEVATION.LOW]
    }
  }
};

const fonts$1 = [{
  provider: 'google',
  family: 'Roboto',
  variants: ['400', '600', '700']
}];

const typography$1 = {
  [TYPOGRAPHY_TAGS.H1]: {
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.H2]: {
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.H3]: {
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '600'
    }
  },
  [TYPOGRAPHY_TAGS.H4]: {
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '600'
    }
  },
  [TYPOGRAPHY_TAGS.P]: {
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '400'
    }
  },
  [TYPOGRAPHY_TAGS.SPAN]: {
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '400'
    }
  }
};

const verticalRhythmStrategies$1 = {
  xLarge: {
    fontSize: 16,
    lineHeight: 1.72,
    fontScaleFactor: 1.33,
    lineHeightMap: {
      h1: 2,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  large: {
    fontSize: 16,
    lineHeight: 1.53,
    fontScaleFactor: 1.25,
    lineHeightMap: {
      h1: 2,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  medium: {
    fontSize: 14,
    lineHeight: 1.5,
    fontScaleFactor: 1.15,
    lineHeightMap: {
      h1: 1.5,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  small: {
    fontSize: 14,
    lineHeight: 1.5,
    fontScaleFactor: 1.15,
    lineHeightMap: {
      h1: 1.5,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  }
};

const palette$1 = {
  colors: colors$1,
  surfaceStyle: surfaceStyle$1,
  fonts: fonts$1,
  typography: typography$1,
  verticalRhythmStrategies: verticalRhythmStrategies$1
};

const configuration$2 = configurationBuilder().overrideColor('primaryHeader', 'backgroundColor', 'primary').overrideColor('primaryLinks', 'hoverStateColor', 'grey').overrideColor('primaryLinks', 'activeStateColor', 'white').overrideColor('primaryLinks', 'activeBorderBottom', 'white').overrideColor('footer', 'separatorColor', 'primary').overrideColor('secondaryLinks', 'hoverStateColor', 'grey').overrideColor('secondaryLinks', 'activeStateColor', 'white').overrideColor('bottomFooterBar', 'backgroundColor', 'primary').overrideColor('mobileTopBar', 'backgroundColor', 'primary').build();

const colors$2 = {
  [COLORS.PRIMARY]: '#6A1B9A',
  [COLORS.SECONDARY]: '#38006B',
  [COLORS.DARK_GREY]: '#445058',
  [COLORS.GREY]: '#9E9E9E',
  [COLORS.LIGHT_GREY]: '#F5F5F5',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const elevation$2 = {
  [ELEVATION.LOW]: '0 2px 4px 0 rgba(0,0,0,0.2)',
  [ELEVATION.HIGH]: '0 8px 8px -8px rgba(0,0,0,0.2), 0 4px 20px 0px rgba(0,0,0,0.2), 0 12px 16px 0px rgba(0,0,0,0.2)'
};
const borderRadius$2 = {
  [BORDER_RADIUS.MEDIUM]: '4px',
  [BORDER_RADIUS.LARGE]: '32px'
};
const surfaceStyle$2 = {
  [SURFACES.EXTEND]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$2[BORDER_RADIUS.MEDIUM],
      boxShadow: elevation$2[ELEVATION.LOW],
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      ':active': {
        boxShadow: elevation$2[ELEVATION.HIGH]
      }
    },
    xLarge: {
      ':hover': {
        boxShadow: elevation$2[ELEVATION.HIGH]
      }
    },
    large: {
      ':hover': {
        boxShadow: elevation$2[ELEVATION.HIGH]
      }
    },
    medium: {
      ':hover': {
        boxShadow: elevation$2[ELEVATION.LOW]
      }
    },
    small: {
      ':hover': {
        boxShadow: elevation$2[ELEVATION.LOW]
      }
    }
  },
  [SURFACES.EXTEND_ROUNDED]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$2[BORDER_RADIUS.LARGE],
      boxShadow: elevation$2[ELEVATION.LOW],
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      ':active': {
        boxShadow: elevation$2[ELEVATION.HIGH]
      }
    },
    xLarge: {
      ':hover': {
        boxShadow: elevation$2[ELEVATION.HIGH]
      }
    },
    large: {
      ':hover': {
        boxShadow: elevation$2[ELEVATION.HIGH]
      }
    },
    medium: {
      ':hover': {
        boxShadow: elevation$2[ELEVATION.LOW]
      }
    },
    small: {
      ':hover': {
        boxShadow: elevation$2[ELEVATION.LOW]
      }
    }
  },
  [SURFACES.NORMAL]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$2[BORDER_RADIUS.MEDIUM],
      boxShadow: elevation$2[ELEVATION.LOW]
    }
  },
  [SURFACES.BORDER_RADIUS]: {
    allSizes: {
      borderRadius: borderRadius$2[BORDER_RADIUS.MEDIUM]
    }
  },
  [SURFACES.BOX_SHADOW]: {
    allSizes: {
      boxShadow: elevation$2[ELEVATION.LOW]
    }
  }
};

const fonts$2 = [{
  provider: 'google',
  family: 'Roboto',
  variants: ['400', '600', '700']
}];

const typography$2 = {
  [TYPOGRAPHY_TAGS.H1]: {
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.H2]: {
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.H3]: {
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '600'
    }
  },
  [TYPOGRAPHY_TAGS.H4]: {
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '600'
    }
  },
  [TYPOGRAPHY_TAGS.P]: {
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '400'
    }
  },
  [TYPOGRAPHY_TAGS.SPAN]: {
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '400'
    }
  }
};

const verticalRhythmStrategies$2 = {
  xLarge: {
    fontSize: 16,
    lineHeight: 1.72,
    fontScaleFactor: 1.33,
    lineHeightMap: {
      h1: 2,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  large: {
    fontSize: 16,
    lineHeight: 1.53,
    fontScaleFactor: 1.25,
    lineHeightMap: {
      h1: 2,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  medium: {
    fontSize: 14,
    lineHeight: 1.5,
    fontScaleFactor: 1.15,
    lineHeightMap: {
      h1: 1.5,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  small: {
    fontSize: 14,
    lineHeight: 1.5,
    fontScaleFactor: 1.15,
    lineHeightMap: {
      h1: 1.5,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  }
};

const palette$2 = {
  colors: colors$2,
  surfaceStyle: surfaceStyle$2,
  fonts: fonts$2,
  typography: typography$2,
  verticalRhythmStrategies: verticalRhythmStrategies$2
};

const configuration$3 = configurationBuilder().overrideColor('moreLinks', 'hoverColor', 'grey').overrideColor('moreLinks', 'activeColor', 'secondary').overrideColor('menuIcon', 'color', 'primary').overrideColor('menuLinks', 'backgroundColor', 'black').overrideColor('menuLink', 'activeStateColor', 'secondary').overrideColor('footerSocialLinks', 'circleColor', 'secondary').overrideColor('bottomFooterBar', 'backgroundColor', 'black').overrideColor('articleTitle', 'titleColor', 'primary').overrideColor('mobileTopBar', 'backgroundColor', 'primary').overrideColor('primaryHeader', 'backgroundColor', 'white').overrideColor('secondaryHeader', 'backgroundColor', 'darkGrey').overrideColor('primaryLinks', 'idleColor', 'darkGrey').overrideColor('primaryLinks', 'visitedStateColor', 'darkGrey').overrideColor('primaryLinks', 'hoverOtherLinksColors', 'darkGrey').overrideColor('secondaryLinks', 'hoverStateColor', 'secondary').overrideColor('secondaryLinks', 'activeStateColor', 'secondary').overrideColor('secondaryLinks', 'hoverOtherLinksColors', 'lightGrey').overrideColor('moreLinks', 'menuBackgroundColor', 'darkGrey').overrideColor('moreLinks', 'hoverColor', 'secondary').overrideColor('editions', 'color', 'darkGrey').overrideColor('editionsMenu', 'color', 'darkGrey').overrideColor('editionsMenu', 'menuBackgroundColor', 'white').overrideColor('editionsMenu', 'hoverColor', 'primary').overrideColor('editionsMenu', 'linkColor', 'darkGrey').overrideColor('editionsMenu', 'activeColor', 'primary').overrideColor('footer', 'backgroundColor', 'darkGrey').overrideColor('footer', 'borderTopColor', 'secondary').overrideColor('footer', 'separatorColor', 'secondary').overrideColor('footerLinksSection', 'hoverStateColor', 'secondary').overrideColor('cardOverlay', 'cardOverlayColor', 'black').overrideColor('decorationLine', 'cardDecorationColor', 'secondary').overrideColor('articleShareButton', 'buttonBackgroundColor', 'secondary').build();

const colors$3 = {
  [COLORS.PRIMARY]: '#020286',
  [COLORS.SECONDARY]: '#1CB1E5',
  [COLORS.DARK_GREY]: '#212121',
  [COLORS.GREY]: '#9E9E9E',
  [COLORS.LIGHT_GREY]: '#F5F5F5',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const elevation$3 = {
  [ELEVATION.LOW]: '0 2px 4px 0 rgba(0,0,0,0.2)',
  [ELEVATION.HIGH]: '0 8px 8px -8px rgba(0,0,0,0.2), 0 4px 20px 0px rgba(0,0,0,0.2), 0 12px 16px 0px rgba(0,0,0,0.2)'
};
const borderRadius$3 = {
  [BORDER_RADIUS.MEDIUM]: '0px',
  [BORDER_RADIUS.LARGE]: '32px'
};
const surfaceStyle$3 = {
  [SURFACES.EXTEND]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$3[BORDER_RADIUS.MEDIUM],
      boxShadow: elevation$3[ELEVATION.LOW],
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      ':active': {
        boxShadow: elevation$3[ELEVATION.HIGH]
      }
    },
    xLarge: {
      ':hover': {
        boxShadow: elevation$3[ELEVATION.HIGH]
      }
    },
    large: {
      ':hover': {
        boxShadow: elevation$3[ELEVATION.HIGH]
      }
    },
    medium: {
      ':hover': {
        boxShadow: elevation$3[ELEVATION.LOW]
      }
    },
    small: {
      ':hover': {
        boxShadow: elevation$3[ELEVATION.LOW]
      }
    }
  },
  [SURFACES.EXTEND_ROUNDED]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$3[BORDER_RADIUS.LARGE],
      boxShadow: elevation$3[ELEVATION.LOW],
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      ':active': {
        boxShadow: elevation$3[ELEVATION.HIGH]
      }
    },
    xLarge: {
      ':hover': {
        boxShadow: elevation$3[ELEVATION.HIGH]
      }
    },
    large: {
      ':hover': {
        boxShadow: elevation$3[ELEVATION.HIGH]
      }
    },
    medium: {
      ':hover': {
        boxShadow: elevation$3[ELEVATION.LOW]
      }
    },
    small: {
      ':hover': {
        boxShadow: elevation$3[ELEVATION.LOW]
      }
    }
  },
  [SURFACES.NORMAL]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$3[BORDER_RADIUS.MEDIUM],
      boxShadow: elevation$3[ELEVATION.LOW]
    }
  },
  [SURFACES.BORDER_RADIUS]: {
    allSizes: {
      borderRadius: borderRadius$3[BORDER_RADIUS.MEDIUM]
    }
  },
  [SURFACES.BOX_SHADOW]: {
    allSizes: {
      boxShadow: elevation$3[ELEVATION.LOW]
    }
  }
};

const fonts$3 = [{
  provider: 'google',
  family: 'Montserrat',
  variants: ['600', '700']
}, {
  provider: 'google',
  family: 'Roboto Slab',
  variants: ['400']
}];

const typography$3 = {
  [TYPOGRAPHY_TAGS.H1]: {
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.H2]: {
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.H3]: {
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '600'
    }
  },
  [TYPOGRAPHY_TAGS.H4]: {
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '600'
    }
  },
  [TYPOGRAPHY_TAGS.P]: {
    fontFamily: 'Roboto Slab',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '400'
    }
  },
  [TYPOGRAPHY_TAGS.SPAN]: {
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '400'
    }
  }
};

const verticalRhythmStrategies$3 = {
  xLarge: {
    fontSize: 16,
    lineHeight: 1.72,
    fontScaleFactor: 1.33,
    lineHeightMap: {
      h1: 2,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  large: {
    fontSize: 16,
    lineHeight: 1.53,
    fontScaleFactor: 1.25,
    lineHeightMap: {
      h1: 2,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  medium: {
    fontSize: 14,
    lineHeight: 1.5,
    fontScaleFactor: 1.15,
    lineHeightMap: {
      h1: 1.5,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  small: {
    fontSize: 14,
    lineHeight: 1.5,
    fontScaleFactor: 1.15,
    lineHeightMap: {
      h1: 1.5,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  }
};

const palette$3 = {
  colors: colors$3,
  surfaceStyle: surfaceStyle$3,
  fonts: fonts$3,
  typography: typography$3,
  verticalRhythmStrategies: verticalRhythmStrategies$3
};

const configuration$4 = configurationBuilder().overrideColor('cardOverlay', 'cardOverlayColor', 'black').overrideColor('editionsMenu', 'menuBackgroundColor', 'black').overrideColor('footer', 'backgroundColor', 'darkGrey').overrideColor('footer', 'separatorColor', 'primary').overrideColor('secondaryHeader', 'backgroundColor', 'darkGrey').overrideColor('moreLinks', 'menuBackgroundColor', 'darkGrey').overrideColor('bottomFooterBar', 'backgroundColor', 'black').overrideColor('editionsMenu', 'hoverColor', 'primary').overrideColor('menuLinks', 'backgroundColor', 'black').build();

const colors$4 = {
  [COLORS.PRIMARY]: '#DC2330',
  [COLORS.SECONDARY]: '#71CDDD',
  [COLORS.DARK_GREY]: '#212121',
  [COLORS.GREY]: '#A1A1A1',
  [COLORS.LIGHT_GREY]: '#F3F3F3',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const elevation$4 = {
  [ELEVATION.LOW]: '0 2px 4px 0 rgba(0,0,0,0.2)',
  [ELEVATION.HIGH]: '0 8px 8px -8px rgba(0,0,0,0.2), 0 4px 20px 0px rgba(0,0,0,0.2), 0 12px 16px 0px rgba(0,0,0,0.2)'
};
const borderRadius$4 = {
  [BORDER_RADIUS.MEDIUM]: '0px',
  [BORDER_RADIUS.LARGE]: '32px'
};
const surfaceStyle$4 = {
  [SURFACES.EXTEND]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$4[BORDER_RADIUS.MEDIUM],
      boxShadow: elevation$4[ELEVATION.LOW],
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      ':active': {
        boxShadow: elevation$4[ELEVATION.HIGH]
      }
    },
    xLarge: {
      ':hover': {
        boxShadow: elevation$4[ELEVATION.HIGH]
      }
    },
    large: {
      ':hover': {
        boxShadow: elevation$4[ELEVATION.HIGH]
      }
    },
    medium: {
      ':hover': {
        boxShadow: elevation$4[ELEVATION.LOW]
      }
    },
    small: {
      ':hover': {
        boxShadow: elevation$4[ELEVATION.LOW]
      }
    }
  },
  [SURFACES.EXTEND_ROUNDED]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$4[BORDER_RADIUS.LARGE],
      boxShadow: elevation$4[ELEVATION.LOW],
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      ':active': {
        boxShadow: elevation$4[ELEVATION.HIGH]
      }
    },
    xLarge: {
      ':hover': {
        boxShadow: elevation$4[ELEVATION.HIGH]
      }
    },
    large: {
      ':hover': {
        boxShadow: elevation$4[ELEVATION.HIGH]
      }
    },
    medium: {
      ':hover': {
        boxShadow: elevation$4[ELEVATION.LOW]
      }
    },
    small: {
      ':hover': {
        boxShadow: elevation$4[ELEVATION.LOW]
      }
    }
  },
  [SURFACES.NORMAL]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$4[BORDER_RADIUS.MEDIUM],
      boxShadow: elevation$4[ELEVATION.LOW]
    }
  },
  [SURFACES.BORDER_RADIUS]: {
    allSizes: {
      borderRadius: borderRadius$4[BORDER_RADIUS.MEDIUM]
    }
  },
  [SURFACES.BOX_SHADOW]: {
    allSizes: {
      boxShadow: elevation$4[ELEVATION.LOW]
    }
  }
};

const fonts$4 = [{
  provider: 'google',
  family: 'Oswald',
  variants: ['400', '600', '700']
}, {
  provider: 'google',
  family: 'Barlow',
  variants: ['400', '600', '700']
}];

const typography$4 = {
  [TYPOGRAPHY_TAGS.H1]: {
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.H2]: {
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '600'
    }
  },
  [TYPOGRAPHY_TAGS.H3]: {
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '400'
    }
  },
  [TYPOGRAPHY_TAGS.H4]: {
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '400'
    }
  },
  [TYPOGRAPHY_TAGS.P]: {
    fontFamily: 'Barlow',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '400'
    }
  },
  [TYPOGRAPHY_TAGS.SPAN]: {
    fontFamily: 'Barlow',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '400'
    }
  }
};

const verticalRhythmStrategies$4 = {
  xLarge: {
    fontSize: 16,
    lineHeight: 1.72,
    fontScaleFactor: 1.33,
    lineHeightMap: {
      h1: 2,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  large: {
    fontSize: 16,
    lineHeight: 1.53,
    fontScaleFactor: 1.25,
    lineHeightMap: {
      h1: 2,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  medium: {
    fontSize: 14,
    lineHeight: 1.5,
    fontScaleFactor: 1.15,
    lineHeightMap: {
      h1: 1.5,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  small: {
    fontSize: 14,
    lineHeight: 1.5,
    fontScaleFactor: 1.15,
    lineHeightMap: {
      h1: 1.5,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  }
};

const palette$4 = {
  colors: colors$4,
  surfaceStyle: surfaceStyle$4,
  fonts: fonts$4,
  typography: typography$4,
  verticalRhythmStrategies: verticalRhythmStrategies$4
};

const configuration$5 = configurationBuilder().build();

const colors$5 = {
  [COLORS.PRIMARY]: '#75CEDC',
  [COLORS.SECONDARY]: '#1B1B1B',
  [COLORS.DARK_GREY]: '#444444',
  [COLORS.GREY]: '#A1A1A1',
  [COLORS.LIGHT_GREY]: '#F3F3F3',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const elevation$5 = {
  [ELEVATION.LOW]: '0 2px 4px 0 rgba(0,0,0,0.2)',
  [ELEVATION.HIGH]: '0 8px 8px -8px rgba(0,0,0,0.2), 0 4px 20px 0px rgba(0,0,0,0.2), 0 12px 16px 0px rgba(0,0,0,0.2)'
};
const borderRadius$5 = {
  [BORDER_RADIUS.MEDIUM]: '4px',
  [BORDER_RADIUS.LARGE]: '32px'
};
const surfaceStyle$5 = {
  [SURFACES.EXTEND]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$5[BORDER_RADIUS.MEDIUM],
      boxShadow: elevation$5[ELEVATION.LOW],
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      ':active': {
        boxShadow: elevation$5[ELEVATION.HIGH]
      }
    },
    xLarge: {
      ':hover': {
        boxShadow: elevation$5[ELEVATION.HIGH]
      }
    },
    large: {
      ':hover': {
        boxShadow: elevation$5[ELEVATION.HIGH]
      }
    },
    medium: {
      ':hover': {
        boxShadow: elevation$5[ELEVATION.LOW]
      }
    },
    small: {
      ':hover': {
        boxShadow: elevation$5[ELEVATION.LOW]
      }
    }
  },
  [SURFACES.EXTEND_ROUNDED]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$5[BORDER_RADIUS.LARGE],
      boxShadow: elevation$5[ELEVATION.LOW],
      transition: '0.2s box-shadow ease-in-out',
      willChange: 'box-shadow',
      ':active': {
        boxShadow: elevation$5[ELEVATION.HIGH]
      }
    },
    xLarge: {
      ':hover': {
        boxShadow: elevation$5[ELEVATION.HIGH]
      }
    },
    large: {
      ':hover': {
        boxShadow: elevation$5[ELEVATION.HIGH]
      }
    },
    medium: {
      ':hover': {
        boxShadow: elevation$5[ELEVATION.LOW]
      }
    },
    small: {
      ':hover': {
        boxShadow: elevation$5[ELEVATION.LOW]
      }
    }
  },
  [SURFACES.NORMAL]: {
    allSizes: {
      overflow: 'hidden',
      borderRadius: borderRadius$5[BORDER_RADIUS.MEDIUM],
      boxShadow: elevation$5[ELEVATION.LOW]
    }
  },
  [SURFACES.BORDER_RADIUS]: {
    allSizes: {
      borderRadius: borderRadius$5[BORDER_RADIUS.MEDIUM]
    }
  },
  [SURFACES.BOX_SHADOW]: {
    allSizes: {
      boxShadow: elevation$5[ELEVATION.LOW]
    }
  }
};

const fonts$5 = [{
  provider: 'custom',
  family: 'itc-avant-garde-gothic-pro',
  variants: ['400', '500', '700'],
  stylesheetUrl: 'https://use.typekit.net/cew3eqg.css'
}, {
  provider: 'custom',
  family: 'europa',
  variants: ['400', '500', '700'],
  stylesheetUrl: 'https://use.typekit.net/cew3eqg.css'
}];

const typography$5 = {
  [TYPOGRAPHY_TAGS.H1]: {
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.H2]: {
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.H3]: {
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.H4]: {
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '700'
    }
  },
  [TYPOGRAPHY_TAGS.P]: {
    fontFamily: 'europa',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '400'
    }
  },
  [TYPOGRAPHY_TAGS.SPAN]: {
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif',
    style: {
      fontWeight: '700'
    }
  }
};

const verticalRhythmStrategies$5 = {
  xLarge: {
    fontSize: 16,
    lineHeight: 1.72,
    fontScaleFactor: 1.33,
    lineHeightMap: {
      h1: 2,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  large: {
    fontSize: 16,
    lineHeight: 1.53,
    fontScaleFactor: 1.25,
    lineHeightMap: {
      h1: 2,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  medium: {
    fontSize: 14,
    lineHeight: 1.5,
    fontScaleFactor: 1.15,
    lineHeightMap: {
      h1: 1.5,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  },
  small: {
    fontSize: 14,
    lineHeight: 1.5,
    fontScaleFactor: 1.15,
    lineHeightMap: {
      h1: 1.5,
      h2: 1.5,
      h3: 1,
      h4: 1,
      p: 1
    }
  }
};

const palette$5 = {
  colors: colors$5,
  surfaceStyle: surfaceStyle$5,
  fonts: fonts$5,
  typography: typography$5,
  verticalRhythmStrategies: verticalRhythmStrategies$5
};

const themeByKey = {
  orangeAndBlack: {
    configuration: configuration$1,
    palette: palette$1
  },
  blueAndGrey: {
    configuration: configuration,
    palette: palette
  },
  purpleAndViolet: {
    configuration: configuration$2,
    palette: palette$2
  },
  thebiglead: {
    configuration: configuration$3,
    palette: palette$3
  },
  dbltap: {
    configuration: configuration$4,
    palette: palette$4
  },
  floor8: {
    configuration: configuration$5,
    palette: palette$5
  }
};

const createTheme = themeKey => {
  if (!themeByKey[themeKey]) {
    throw new Error(`${themeKey} is not a valid themeKey`);
  }

  const {
    configuration,
    palette
  } = themeByKey[themeKey];
  return {
    palette,
    configuration
  };
};

const getThemeByKey = themeKey => {
  return createTheme(themeKey);
};

export { COLORS, CONFIGURATION_TYPES, SURFACES, TYPOGRAPHY_TAGS, VR_LINEHEIGHT, getThemeByKey };
//# sourceMappingURL=index.bundle.esm.js.map
